import { ReactNode } from 'react';

import 'dayjs/locale/pt';
import 'dayjs/locale/en';
import 'dayjs/locale/ar';
import { useIntl } from '@apigrowfinance/pbolt-intl-provider';
import * as dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import duration from 'dayjs/plugin/duration';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import relativeTime from 'dayjs/plugin/relativeTime';

// This component sets the locale of dayjs. It is not done in the app.js as we need access the locale value from the intl provider.
const DayjsLocal = ({ children }: { children: ReactNode }) => {
    const { locale } = useIntl();
    dayjs.locale(locale);
    dayjs.extend(relativeTime);
    dayjs.extend(duration);
    dayjs.extend(isSameOrAfter);
    dayjs.extend(customParseFormat);
    return <>{children}</>;
};

export default DayjsLocal;
